import request from '@/utils/request'

export function getSubjectMappingOptions() {
    return request({
        url: '/api/admin/subject-mapping/list',
        method: 'get'
    })
}